
import { capitalizeFirstLetter } from "../../utils/Helper";

const messageData = {
    "enter_email_address": "Enter your email address"
}

const ValidationMessage = {
    Field: (name: any) => `Please enter your ${name}.`,
    MinLength: (name: string, length: number) => `${capitalizeFirstLetter(name)} must be at least ${length} characters.`,
    MaxLength: (name: string, length: number) => `${capitalizeFirstLetter(name)} cannot exceed more than ${length} characters.`,
    // OnlyAlphabets: (name: string) => `Your ${capitalizeFirstLetter(name)} should contain only letters and spaces`,

    EMAIL_ADDRESS: 'Please enter valid email address.',
    EMAIL_REGREX: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    // EMAIL_REGREX: /^[a-zA-Z0-9.%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,

    // EMAIL_REGREX: /^[a-zA-Z0-9.%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$/,
    ANY_REQUIRED: 'Please enter your ',
    ANY_SELECT: 'Please select your ',
    START_TIME: "Please enter start time",
    END_TIME: "Please enter end time ",

    PHONE_REQUIRED: "Please enter your phone number.",
    // VALID_PHONE_NUMBER: "Please enter valid phone number",
    VALID_PHONE_NUMBER: "Phone number must be at last 7 numbers.",
    VALID_PHONE: "Please enter valid phone number",
    PHONE_MAX_CHAR: "Phone number cannot exceed more than 15 numbers.",

    OneSpaceOnly: (field: any) => `${field} must not contain more than one consecutive space.`,


    CONFIRM_PASSWORD_VALID: "Password must have uppercase, lowercase, special character and number.",

    PASSWORD_CONFIRM_PASSWORD_MUST_MATCH: "Password and confirm password must be same",

    NO_SPACE_ALLOWED: "Space is not allowed.",


    PASSWORD_UPPER_CASE: "Password must contain alphanumeric characters that includes atleast 1 uppercase, 1 lowercase and 1 special character.",
    PASSWORD_MATCH: "Password should be between 8 to 15 characters and should contain atleat one uppercase, one lowercase, one number and one special character.",
    IMAGE: "Please select  images",
    // Selection
    SelectField: (name: string) => `Please select ${name}`,
    MinField: (length: any, name: string) => `Please select at least ${length} ${name} `,
    MaxField: (length: any, name: string) => `${name} must not be exceed {length} `
}


export default ValidationMessage;

/*
import { capitalizeFirstLetter } from "../../utils/Helper";
import getFormattedMessage from "./getFormattedMessage";

const ValidationMessage = {
    Field: (name: any) => getFormattedMessage('field_required', { name, defaultMessage: `Please enter your ${name}.` }),
    MinLength: (name: any, length: any) => getFormattedMessage('min_length', { name: capitalizeFirstLetter(name), length, defaultMessage: `${capitalizeFirstLetter(name)} must be at least ${length} characters.` }),
    MaxLength: (name: any, length: any) => getFormattedMessage('max_length', { name: capitalizeFirstLetter(name), length, defaultMessage: `${capitalizeFirstLetter(name)} cannot exceed more than ${length} characters.` }),
    EMAIL_ADDRESS: getFormattedMessage('email_address', { defaultMessage: 'Please enter a valid email address.' }),
    ANY_REQUIRED: getFormattedMessage('any_required', { defaultMessage: 'Please enter your information.' }),
    ANY_SELECT: getFormattedMessage('any_select', { defaultMessage: 'Please select your information.' }),
    START_TIME: getFormattedMessage('start_time', { defaultMessage: 'Please enter start time' }),
    END_TIME: getFormattedMessage('end_time', { defaultMessage: 'Please enter end time' }),
    PHONE_REQUIRED: getFormattedMessage('phone_required', { defaultMessage: 'Please enter your phone number.' }),
    VALID_PHONE_NUMBER: getFormattedMessage('valid_phone_number', { defaultMessage: 'Phone number must be at least 7 numbers.' }),
    VALID_PHONE: getFormattedMessage('valid_phone', { defaultMessage: 'Please enter valid phone number' }),
    PHONE_MAX_CHAR: getFormattedMessage('phone_max_char', { defaultMessage: 'Phone number cannot exceed more than 15 numbers.' }),
    OneSpaceOnly: (field: any) => getFormattedMessage('one_space_only', { field, defaultMessage: `${field} must not contain more than one consecutive space.` }),
    CONFIRM_PASSWORD_VALID: getFormattedMessage('confirm_password_valid', { defaultMessage: 'Password must have uppercase, lowercase, special character and number.' }),
    PASSWORD_CONFIRM_PASSWORD_MUST_MATCH: getFormattedMessage('password_confirm_password_must_match', { defaultMessage: 'Password and confirm password must be the same' }),
    NO_SPACE_ALLOWED: getFormattedMessage('no_space_allowed', { defaultMessage: 'Space is not allowed.' }),
    PASSWORD_UPPER_CASE: getFormattedMessage('password_upper_case', { defaultMessage: 'Password must contain alphanumeric characters that include at least 1 uppercase, 1 lowercase, and 1 special character.' }),
    PASSWORD_MATCH: getFormattedMessage('password_match', { defaultMessage: 'Password should be between 8 to 15 characters and should contain at least one uppercase, one lowercase, one number, and one special character.' }),
    IMAGE: getFormattedMessage('image', { defaultMessage: 'Please select images' }),
    SelectField: (name: string) => getFormattedMessage('select_field', { name, defaultMessage: `Please select ${name}` }),
    MinField: (length: any, name: string) => getFormattedMessage('min_field', { length, name, defaultMessage: `Please select at least ${length} ${name}` }),
    MaxField: (length: any, name: string) => getFormattedMessage('max_field', { length, name, defaultMessage: `${name} must not exceed ${length}` }),
};

export default ValidationMessage;

*/